import { useResourceBundle } from '../contexts/ResourceContext';
import useComment from '../hooks/useComment';
import { navigationActions } from '../store/navigation.slice';
import Comment from './Comment';

const ClaimComment = () => {
  const resource = useResourceBundle();
  const [comment, saveComment] = useComment<string>(
    (state) => state.navigation.selections.injury.comment ?? '',
    navigationActions.saveClaimComment
  );

  return <Comment label={resource['label.comment']} value={comment} setValue={saveComment} />;
};

export default ClaimComment;
